import Input from "./input";
import InputMask from "./inputMask";
import InputMaskSum from "./inputMaskSum";
import Password from "./password";
import Select from "./select";
import SelectD from "./selectD";
import AsyncSelect from "./ant-async-select";
import AsyncSelectD from "./asyncSelectD";
import DatePicker from "./datePicker";
import FileUpload2 from "./fileUpload";
import FileUploadDZ from "./fileUploadReact";
import FileUploadBanner from "./fileUploadBanner";
import FileUpload from "./fileUploadReact2";
import Textarea from "./textarea";
import Radio from "./radio";
import TreeSelect from "./treeSelect";
import Search from "./Search";
import Ckeditor from "./ckeditor";

import {
  AntInput,
  AntTextarea,
  AntSelect,
  AntTimePicker,
  AntPassword,
  AntTreeSelect,
  AntInputNumber,
  AntRadio,
} from "./AntFields";

export default {
  Input,
  InputMask,
  InputMaskSum,
  Password,
  Select,
  SelectD,
  TreeSelect,
  Search,
  AsyncSelect,
  AsyncSelectD,
  DatePicker,
  FileUpload,
  FileUploadBanner,
  FileUploadDZ,
  Textarea,
  AntInput,
  Radio,
  AntTextarea,
  AntSelect,
  AntTimePicker,
  AntPassword,
  AntTreeSelect,
  AntInputNumber,
  AntRadio,
  Ckeditor,
  FileUpload2
};